import { WEBVIEW_ERROR_MESSAGE } from '@/config/constants';
import { logError } from '@/utils/logHandling';
import { forwardRef } from 'react';
import { Alert, View } from 'react-native';
import { WebView as NativeWebView, WebViewProps } from 'react-native-webview';

type Props = {
  source: WebViewProps['source'];
  onLoadEnd: WebViewProps['onLoadEnd'];
};

export const WebView = forwardRef<NativeWebView, Props>((props: Props, ref) => {
  const onError: WebViewProps['onError'] = (e) => {
    try {
      const { description } = e.nativeEvent;
      Alert.alert(WEBVIEW_ERROR_MESSAGE.onError);
      const customError = new Error(description);
      logError(WEBVIEW_ERROR_MESSAGE.onError, customError);
    } catch (error) {
      if (error instanceof Error)
        logError(WEBVIEW_ERROR_MESSAGE.catchOnError, error);
      Alert.alert('Fehler!', WEBVIEW_ERROR_MESSAGE.catchOnError);
    }
  };

  const onMessageError: WebViewProps['onMessage'] = (e) => {
    try {
      const { data } = e.nativeEvent;
      const { context, error } = JSON.parse(data) ?? { context: '', error: '' };
      Alert.alert(WEBVIEW_ERROR_MESSAGE.onMessage);
      const customError = new Error(`${error} (${context})`);
      logError(WEBVIEW_ERROR_MESSAGE.onError, customError);
    } catch (error) {
      if (error instanceof Error)
        logError(WEBVIEW_ERROR_MESSAGE.onError, error);
      Alert.alert('Fehler!', WEBVIEW_ERROR_MESSAGE.catchOnMessage);
    }
  };

  return (
    <View className="flex-1 w-full h-full">
      <NativeWebView
        ref={ref}
        className="flex-1 w-full h-full"
        scrollEnabled
        originWhitelist={['*']}
        onError={onError}
        onMessage={onMessageError}
        onShouldStartLoadWithRequest={(request) => {
          // Only allow navigating the static file we provide for statistic display and not any webpages
          return request.url === 'about:blank';
        }}
        {...props}
      />
    </View>
  );
});

WebView.displayName = 'WebView';
